(function () {
    'use strict';

    var module = angular.module('imApp');

    module.component('tsMenu', {
        templateUrl: 'views/components/views/tsMenu/tsMenu.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['stateService', function (stateService) {
            var vm = this;

            vm.model = {
                name: stateService.getCurrentName()
            };
        }]
    });
})();